let css = require('./actions.css');
let signalsAddParams = require('../../../../../../../signals/custom-order/additional-parameters');
let { cut } = require('../../../../../../../helpers/utils');

class Actions {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [cut(css.setAll)]: this.setAll,
                [cut(css.clearAll)]: this.clearAll
            }
        };
    }

    setAll (e) {
        e.preventDefault();
        this.$context.signal(signalsAddParams.setAllGreederColumns, { value: true });
    }

    clearAll (e) {
        e.preventDefault();
        this.$context.signal(signalsAddParams.setAllGreederColumns, { value: false });
    }
}

module.exports = {
    constructor: Actions
};



// WEBPACK FOOTER //
// ./components/common/custom-order/additional-parameters/content/greeder-columns/actions/index.js